module.exports = __webpack_public_path__ + "static/photo9-3f5dbbf07161b95735a160ad9e7e20c9.jpg";